export let chart: any = undefined;
export function setState(newValue: any) {
    chart = newValue;
}


// WEBPACK FOOTER //
// ./src/common/charts/global-state/state.ts